import { render, staticRenderFns } from "./MultiEditDialog.vue?vue&type=template&id=2e84d3b4&scoped=true"
import script from "./MultiEditDialog.vue?vue&type=script&lang=js"
export * from "./MultiEditDialog.vue?vue&type=script&lang=js"
import style0 from "./MultiEditDialog.vue?vue&type=style&index=0&id=2e84d3b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e84d3b4",
  null
  
)

export default component.exports